
import O1HD, { modules, services } from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { UIKind } from "../../../../define/UIKind";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../../BundleResourceConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import { KaoguDataHelp, MysticalHoleMansion } from "./config/kaoguDataHelp";
import { getKaoguMountainConfig } from "./config/kaoguMountainConfig";
import kaoguMinePage from "./kaoguMinePage";

const { ccclass, property } = cc._decorator;

@ccclass
export default class kaoguMountainPage extends cc.Component {
    @property({ type: cc.Node, displayName: "换一批按钮" })
    node_btnchange: cc.Node = null;
    @property({ type: cc.Node, displayName: "可选考古山" })
    mountain_group: cc.Node = null;
    @property({ type: cc.Label, displayName: "泥土物件数量" })
    lab_insideNum: cc.Label = null;
    @property(cc.Node)
    nodeCollect: cc.Node = null;
    @property(cc.Node)
    nodeSpecialPre: cc.Node = null;
    @property(cc.Node)
    nodeSpecialFinish: cc.Node = null;
    @property(cc.Node)
    nodeOpenSpecial: cc.Node = null;

    protected onLoad(): void {
        KaoguDataHelp.init(NormalGameManager._instance.getGameData().kaoguData);
        O1HD.on(MessageEventKind.EventName.GAME_KAOGUDATA, this.refresh, this)
        this.refresh();

        utilsView.enterLayerDispose(UIKind.UILayerTag.KaoGuLayer, this.node);

        this.nodeSpecialPre.active = true;
        this.nodeSpecialFinish.active = false;

        this.refreshCollectState();
        
        O1HD.on(MessageEventKind.EventName.REFRESH_KAOKU_COLLECT_STATE, this.refreshCollectState, this);
    }

    protected update(dt: number): void {
        this.lab_insideNum.string = `x${KaoguDataHelp.getEarthIDList().length}`
        let has: boolean = false;
        let mountainInfo = KaoguDataHelp.getData().mountainInfo;
        if (!mountainInfo) {
            return;
        }
        for (let info of mountainInfo) {
            if (info.ismine) {
                has = true;
                break;
            }
        }
        // this.node_btnchange.active =has
    }

    refresh() {
        let mountainInfo2 = KaoguDataHelp.getData().mountainInfo;
        if (!mountainInfo2) {
            return;
        }
        let mountainInfo = KaoguDataHelp.getData().mountainInfo.concat();
        mountainInfo.reverse()
        for (let i = 0, len = this.mountain_group.childrenCount; i < len; i++) {
            let data = mountainInfo[i];
            let node = this.mountain_group.children[i]

            let hasKaogu = node.getChildByName("hasKaogu");
            hasKaogu.active = data.ismine;
            // if (!data.ismine) {
            let labName = node.getChildByName("labName").getComponent(cc.Label);
            let labPrice = node.getChildByName("labPrice").getComponent(cc.Label);
            let info = getKaoguMountainConfig[data.id];
            labName.string = info.nickName;
            labPrice.string = `${data_control.getNumberFormat(info.buyPrice)}`
            // }


            node.targetOff(this);
            node.on(cc.Node.EventType.TOUCH_END, () => {
                O1HD.getManagers().soundMgr.playSound('anNiu');
                if (!data.ismine) this.onClickMountain(data.id)
                else O1HD.getModules().uiControlModule.showMessageBox("今日已考古该地")
            }, this)
        }
    }

    clickTime: number = null;
    async onClickMountain(id: number) {
       
        if (this.clickTime != null && new Date().getTime() - this.clickTime < 300) return;
        this.clickTime = new Date().getTime()
        id = Number(id);

        let mountainInfo = KaoguDataHelp.getData().mountainInfo;
        if (mountainInfo[id].ismine) return modules().uiControlModule.showMessageBox("已经考古过了");



        let oilfieldid = mountainInfo[id].id;
        let info = getKaoguMountainConfig[oilfieldid];

        if (O1HD.getServices().userSrv.getCoins() <= info.buyPrice) {
            return modules().uiControlModule.showMessageBox("金额不足，无法购买");
        }
        O1HD.getServices().userSrv.setCoins(-info.buyPrice, true);
        KaoguDataHelp.setKaogu(info.id)

        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.kaogu, "kaogu/kaoguMinePage");
        let node:cc.Node = cc.instantiate(prefab);
        node.setParent(O1HD.Canvas()); 
        node.getComponent(kaoguMinePage).init(info.id)



        // // 弹窗显示
        // let page: PageBase;
        // let prams: OilFieldBuyPrams = {
        //     id: info.id,
        //     callBack: async () => {
        //         // 开采了

        //         if (O1HD.getServices().userSrv.getCoins() <= info.buyPrice) {
        //             return modules().uiControlModule.showMessageBox("金额不足，无法购买");
        //         }
        //         O1HD.getServices().userSrv.setCoins(-info.buyPrice, true);
        //         KaoguDataHelp.setKaogu(info.id)

        //         O1HD.getManagers().soundMgr.playSound('anNiu');

        //         let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.kaogu, "kaogu/kaoguMinePage");
        //         let node:cc.Node = cc.instantiate(prefab);
        //         node.setParent(O1HD.Canvas()); 
        //         node.getComponent(kaoguMinePage).init(info.id)
        //     }
        // }
        // page = await modules().uiControlModule.OpenPage("kaogu/kaoguBuyPage", UI_Z_INDEX.DIALOG, prams, getOneBundleByInstant(BUNDLE_SMALL_NAME.kaogu), true);
    }

    refreshCollectState() {
        let colletConfig = MysticalHoleMansion;
        let cCount = 0;
        this.nodeCollect.children.forEach((v, i)=> {
            let item = colletConfig[i];
            let goods = NormalGameManager._instance.getOneGood(item);
            v.active = true;
            if (!goods || goods.num <= 0)  {
                v.active = false;
            } else {
                cCount++;
            }
        });

        this.nodeOpenSpecial.active = cCount >= colletConfig.length;
    }

    onClickBack() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.node && this.node.isValid && this.node.destroy();
    }

    onClickOpenSpecial() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (this.clickTime != null && new Date().getTime() - this.clickTime < 300) return;
        this.clickTime = new Date().getTime();

        if (!this.isOwnSpecialGoods()) {
            return;
        }
        this.enterSpecialDF();
       
    }

    enterSpecialDF() {
        for (let o of MysticalHoleMansion) {
            NormalGameManager._instance.onOutGoods(o, 1);
        }

        this.refreshCollectState();
        utilsView.openPopupLayer(
            'kaogu/KaoGuSpecialPage'
            , BUNDLE_SMALL_NAME.kaogu
        );
    }

    isOwnSpecialGoods() {
        for (let o of MysticalHoleMansion) {
            let goods = NormalGameManager._instance.getOneGood(o);
            if (!goods || goods.num <= 0) {
                return false;
            }
        }
        return true;
    }

    async onClickGuaEarth() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (!KaoguDataHelp.getEarthIDList() || KaoguDataHelp.getEarthIDList().length <= 0) {
            modules().uiControlModule.showMessageBox("无泥土物件");
            return
        }

        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.kaogu, "kaoguArticle/kaoguArticlePage");
        let node:cc.Node = cc.instantiate(prefab);
        node.setParent(O1HD.Canvas()); 
    }

    onClickChange() {

        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (this.clickTime != null && new Date().getTime() - this.clickTime < 3000) return;
        this.clickTime = new Date().getTime()

        let func = () => {
            KaoguDataHelp.changeNext();
        }
        cc.game.pause();
        utilsModel.loadAndShowVideoAdTrans(async () => {
            cc.game.resume();
            func();
        }, () => {
            cc.game.resume();
        }, null, '更换矿山')
    }

    onClickMountainSpecial() {
        O1HD.getManagers().soundMgr.playSound('anNiu');


        if (this.isOwnSpecialGoods()) {
            this.enterSpecialDF();
            return;
        }
        

        utilsView.openEventLayer(
            null
            , {
                id: '28'
                , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                , saveData: ()=> {
                   
                }
                , exitLayer: ()=> {
                    
                }
            }
            , UI_Z_INDEX.DIALOG
        );
    }

}